var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-snackbar",
    {
      attrs: {
        id: "toast",
        color: _vm.color,
        timeout: 0,
        "auto-height": "",
        top: ""
      },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "iconToast",
            staticStyle: {
              float: "left",
              "margin-right": "10px",
              "margin-left": "-10px"
            }
          },
          [
            _c("v-icon", { attrs: { color: "white" } }, [
              _vm._v("\n        error_outline\n      ")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.data.message.header !== undefined
          ? _c("div", { staticStyle: { display: "table" } }, [
              _c("div", [
                _c("h3", { staticClass: "headerToast" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.data.message.header) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "messageToast" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.data.message.message) + "\n      "
                )
              ])
            ])
          : _c("div", { staticClass: "messageWithoutHeaderToast" }, [
              _vm._v("\n      " + _vm._s(_vm.data.message.message) + "\n    ")
            ])
      ]),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { flat: "", color: "white" },
          nativeOn: {
            click: function($event) {
              _vm.show = false
            }
          }
        },
        [_c("v-icon", [_vm._v("\n      close\n    ")])],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }